import type { TChatMessage } from '../model/types';

const getNotReadChatMessagesIds = (chatMessages: TChatMessage[]) => {
  const ids: string[] = [];

  for (const chatMessage of chatMessages) {
    if (chatMessage.IsRead) continue;

    ids.push(chatMessage.Id);
  }

  return ids;
};

export default getNotReadChatMessagesIds;
